import React from "react";
import FunnelInsightCard from "./FunnelInsightCard";
import {
  cleanLines,
  extractTitle,
  stripTitleLines,
  toBullets,
  toParagraphs,
  extractVerdict,
} from "./funnelUtils";

const FunnelReturnsRefunds = ({ markdown = "" }) => {
  const title = extractTitle(markdown) || "Returns & Refunds";
  const lines = stripTitleLines(cleanLines(markdown));
  const bullets = toBullets(lines);
  let paragraphs = toParagraphs(lines);
  const verdict = extractVerdict(paragraphs);
  if (verdict) paragraphs = paragraphs.slice(0, -1);

  return (
    <FunnelInsightCard
      title={title}
      kicker="Leakage Check"
      sections={[
        {
          title: "Observed Signals",
          bullets,
          paragraphs,
          verdict,
        },
      ]}
    />
  );
};

export default FunnelReturnsRefunds;
